import { DocumentData } from "firebase/firestore";
import { Chart, ChartDocData } from "@usacsmideo/types";

// Format Firestore response
export function formatChart(response: DocumentData) {
  if (response.docs) {
    const retObj = {} as Chart;
    response.docs.forEach((doc: ChartDocData) => {
      const data = formatDoc(doc);
      const key = Object.keys(data)[0] as keyof Chart;
      const value = data[key]; // TODO: WOULD BE NICE TO GET THIS TYPED
      retObj[key] = value;
    });
    return retObj;
  } else {
    return formatDoc(response);
  }
}

// Format document (merges `doc.data()` and `doc.id`)
function formatDoc(doc: DocumentData) {
  const id = doc.id as string;
  return { [id]: { ...doc.data() } };
}
